import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=1d950fb4&scoped=true&"
import script from "./LocalePicker.vue?vue&type=script&lang=ts&"
export * from "./LocalePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d950fb4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VImg,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d950fb4')) {
      api.createRecord('1d950fb4', component.options)
    } else {
      api.reload('1d950fb4', component.options)
    }
    module.hot.accept("./LocalePicker.vue?vue&type=template&id=1d950fb4&scoped=true&", function () {
      api.rerender('1d950fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/LocalePicker.vue"
export default component.exports